import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NexusAccessService } from 'src/app/services/nexusaccess.service';
import { NexusModule } from 'src/app/models/enum/nexus-module';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatNavList, MatListItem, MatIconModule, RouterModule, MatDivider],
})
export class NavMenuComponent {
  isExpanded = true;
  isShowing = false;
  currentUrl = location.pathname;

  constructor(
    public access: NexusAccessService,
    public organizationsService: GumOrganizationsService
  ) {}

  NexusModule = NexusModule; // pour l’utiliser dans le HTML
}
